export default __webpack_public_path__ + "static/thumbnail-66777cf8f99eb084ee475a065ddbafe4.png";